import { useTranslation } from 'react-i18next';

import { getEvaluationChiefFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';
import { useEvaluationUploadChiefFile } from '@/module/Evaluation/model/EvaluationQuery';

import { Id, PersistentFile, useAppNotification } from '@feature/utils';

import { EvaluationAuthorFile } from './EvaluationAuthorFile';

interface EvaluationAuthorChiefFileProps {
  userId: Id;
  evaluationId: Id;
  file: PersistentFile | null;
}

export function EvaluationAuthorChiefFile({ evaluationId, userId, file }: EvaluationAuthorChiefFileProps) {
  const { mutate, isPending } = useEvaluationUploadChiefFile(evaluationId, userId);
  const notification = useAppNotification();
  const { t } = useTranslation();

  const onUpload = (newFile: File) => {
    mutate(newFile, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <EvaluationAuthorFile
      onUpload={onUpload}
      file={file}
      onDownload={() => window.open(getEvaluationChiefFileDownloadUrl(evaluationId, userId))}
      isSubmitting={isPending}
      label={t('evaluation.files.chief.label')}
      description={t('evaluation.files.chief.description')}
    />
  );
}
